import { inject, Injectable } from "@angular/core";
import { FiatService } from "@main-services/currency";
import { Fiat } from "@models";
import { FiatPrecisionSymbolPipe } from "@modules/core/pipes";

//TODO: IMPORTANT: Move this file to real-stocks module once RS master branch is merged to master
// this resided folder is just temporary to to avoid conflicts during the merge

@Injectable({
	providedIn: "root"
})
export class RealStocksFacade {
	private fiatService = inject(FiatService);
	private fiatPrecisionSymbolPipe = inject(FiatPrecisionSymbolPipe);

	private getDefaultFiat(): Fiat {
		return new Fiat();
	}

	// This function replicates the current logic in the mobile apps
	// These fees/currencies are hardcoded in the client as a simplification
	// If the default wallet is not in the list, we default to 1 EUR
	public getRSFeeFormatted(): string {
		const defaultFiat = this.getDefaultFiat();
		const defaultSymbol = defaultFiat.getSymbol();
		const fees = {
			EUR: 1,
			USD: 1,
			CHF: 1,
			GBP: 1,
			TRY: 50,
			PLN: 4,
			HUF: 400,
			CZK: 20,
			SEK: 10,
			DKK: 10,
			RON: 5,
			BGN: 2
		};
		const symbol = defaultSymbol in fees ? defaultSymbol : "EUR";
		const fee = symbol in fees ? fees[symbol] : 1;
		const fiat = this.fiatService.list.filter((fiat) => fiat.getSymbol() === symbol)[0];
		return this.fiatPrecisionSymbolPipe.transform(fee, {
			id: fiat.getId(),
			currencies: [fiat],
			noTrailingZeros: true,
			symbol: true
		});
	}
}
